import { Usuario } from '../usuarios/usuario';
export class Aviso {
	_id: string;
	nombre: string;
	lunes: Boolean;
	martes: Boolean;
	miercoles: Boolean;
	jueves: Boolean;
	viernes: Boolean;
	sabado: Boolean;
	domingo: Boolean;
	horaDesde: string;
	horaHasta: string;
	estado: boolean;
	usuarios: Usuario[];
	sucursal_id: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/aviso/aviso.ts